import { render, staticRenderFns } from "./AskAIDetailComponent.vue?vue&type=template&id=e24f9b48&scoped=true&"
import script from "./AskAIDetailComponent.vue?vue&type=script&lang=js&"
export * from "./AskAIDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./AskAIDetailComponent.vue?vue&type=style&index=0&id=e24f9b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24f9b48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCardText,VCheckbox,VCol,VRadio,VRadioGroup,VRow,VSelect,VTextField,VTextarea})
